import React from 'react'
import IntroFinsta from './IntroFinsta'
import StatsSection from './StatsSection'
import Cards from './Cards'
import ClientLogo from './ClientLogo'
import ClientTestimonials from './ClientTestimonials'
import { Helmet } from 'react-helmet';

const Finsta= () => {

  return (
    <div >
      <Helmet>
        <title>PT KCS | Finsta – Financial Management & Transformation Solutions Indonesia</title>
        <meta 
          name="description" 
          content="PT KCS offers Finsta, a comprehensive financial management solution for streamlined accounting, budgeting, and automated financial reporting in Indonesia." 
        />
        <meta 
          name="keywords" 
          content="PT KCS, PT KCS Tech Indonesia, Finsta, financial management solution Jakarta, accounting automation software Indonesia, business budgeting tools, digital financial transformation, automated reporting, compliance, operational efficiency" 
        />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="author" content="PT KCS" />
      </Helmet>

            <div >
        <IntroFinsta />
        <ClientLogo />
        <StatsSection />
        <Cards />
        <ClientTestimonials/>
     </div>
    </div>
  )
}

export default Finsta
